/** @file Crockford base32 alphabet used by ids (no I, L, O, U). */

/** The 32 Crockford base32 digits in value order. */
export const CROCKFORD_BASE32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
